import { PredictiveAnalysis, IOTDataPoint, IOGPRequirement } from "./models";

// Mock IOGP Requirements
export const mockIOGPRequirements: IOGPRequirement[] = [
  {
    id: "IOGP-001",
    requirement:
      "Equipment temperature must not exceed 85°C for more than 2 hours",
    priority: "high",
    threshold: 85,
    category: "Temperature Control"
  },
  {
    id: "IOGP-002",
    requirement: "Vibration levels should remain below 8.0 mm/s RMS",
    priority: "medium",
    threshold: 8,
    category: "Vibration Monitoring"
  },
  {
    id: "IOGP-003",
    requirement:
      "Pressure levels should remain between 40-60 PSI during operation",
    priority: "medium",
    threshold: 60,
    category: "Pressure Management"
  },
  {
    id: "IOGP-004",
    requirement: "Equipment must undergo preventive maintenance every 30 days",
    priority: "low",
    category: "Maintenance Schedule"
  },
  {
    id: "IOGP-005",
    requirement:
      "Critical equipment temperature must not exceed 90°C under any circumstances",
    priority: "high",
    threshold: 90,
    category: "Safety Limits"
  }
];

// Mock Predictive Analysis Data
export const mockPredictiveAnalysis: PredictiveAnalysis[] = [
  {
    equipmentId: "PUMP-A-01",
    equipmentName: "Primary Circulation Pump",
    currentStatus: "warning",
    predictedFailureDate: "2024-12-05",
    confidence: 78,
    recommendations: [
      "Schedule bearing inspection within 7 days",
      "Monitor vibration levels every 4 hours",
      "Prepare replacement parts",
      "Plan 4-hour maintenance window"
    ],
    complianceStatus: "warning",
    relatedRequirements: [mockIOGPRequirements[0], mockIOGPRequirements[1]]
  },
  {
    equipmentId: "COMP-B-01",
    equipmentName: "Gas Compressor Unit B",
    currentStatus: "critical",
    predictedFailureDate: "2024-11-20",
    confidence: 92,
    recommendations: [
      "IMMEDIATE ACTION REQUIRED: Temperature exceeds safe limits",
      "Reduce operational load immediately",
      "Schedule emergency maintenance",
      "Notify operations and safety teams"
    ],
    complianceStatus: "non-compliant",
    relatedRequirements: [mockIOGPRequirements[4]]
  },
  {
    equipmentId: "PUMP-C-02",
    equipmentName: "Secondary Transfer Pump",
    currentStatus: "operational",
    confidence: 95,
    recommendations: [
      "Continue normal operations",
      "Standard maintenance scheduled for next month",
      "All parameters within normal range"
    ],
    complianceStatus: "compliant",
    relatedRequirements: []
  }
];

// Mock IOT Data
export const mockIOTData: IOTDataPoint[] = [
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "TEMP-001",
    equipmentId: "PUMP-A-01",
    metric: "temperature",
    value: 85.4,
    unit: "celsius",
    status: "warning"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "VIB-001",
    equipmentId: "PUMP-A-01",
    metric: "vibration",
    value: 7.2,
    unit: "mm/s",
    status: "warning"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "PRESS-001",
    equipmentId: "PUMP-A-01",
    metric: "pressure",
    value: 245,
    unit: "psi",
    status: "normal"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "TEMP-002",
    equipmentId: "COMP-B-01",
    metric: "temperature",
    value: 92.1,
    unit: "celsius",
    status: "critical"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "VIB-002",
    equipmentId: "COMP-B-01",
    metric: "vibration",
    value: 12.8,
    unit: "mm/s",
    status: "critical"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "PRESS-002",
    equipmentId: "COMP-B-01",
    metric: "pressure",
    value: 185,
    unit: "psi",
    status: "normal"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "TEMP-003",
    equipmentId: "PUMP-C-02",
    metric: "temperature",
    value: 68.2,
    unit: "celsius",
    status: "normal"
  },
  {
    timestamp: "2024-11-17 10:30:00",
    sensorId: "VIB-003",
    equipmentId: "PUMP-C-02",
    metric: "vibration",
    value: 4.1,
    unit: "mm/s",
    status: "normal"
  }
];
